import { Injectable } from '@angular/core';
import { CountryWithDialingCode } from '@gelato-api-ui/sdk/src/lib/shared/country-selector/types/country-selector';
import { CountryCode, getExampleNumber, parsePhoneNumber, PhoneNumber } from 'libphonenumber-js';
import examples from 'libphonenumber-js/examples.mobile.json';

@Injectable({ providedIn: 'root' })
export class PhoneNumberService {
  getCountryCodeByPhonePrefix(countries: CountryWithDialingCode[], phonePrefix: string): CountryCode {
    const country = countries.find(
      (loopCountry: CountryWithDialingCode): boolean => loopCountry.dialingCode === phonePrefix,
    );

    return country ? (country.code as CountryCode) : null;
  }

  getExamplePhoneNumberByCountryCode(countryCode: CountryCode, isForUiControl: boolean): string {
    const phoneNumber = getExampleNumber(countryCode, examples);

    return this.phoneNumberToString(phoneNumber, isForUiControl);
  }

  getFormattedPhoneNumberByCountryCode(countryCode: CountryCode, phoneNumber: string, isForUiControl: boolean): string {
    const parsedPhoneNumber = parsePhoneNumber(phoneNumber, countryCode);

    return this.phoneNumberToString(parsedPhoneNumber, isForUiControl);
  }

  getFormattedPhoneNumberByPhonePrefix(
    countries: CountryWithDialingCode[],
    phonePrefix: string,
    phoneNumber: string,
    isForUiControl: boolean,
  ): string {
    if (!phonePrefix || !phoneNumber) {
      return phoneNumber;
    }

    const countryCode: CountryCode = this.getCountryCodeByPhonePrefix(countries, phonePrefix);

    return this.getFormattedPhoneNumberByCountryCode(countryCode, phoneNumber, isForUiControl);
  }

  private phoneNumberToString(phoneNumber: PhoneNumber, isForUiControl: boolean): string {
    if (!phoneNumber) {
      return '';
    }

    return isForUiControl ? phoneNumber.formatNational() : (phoneNumber.nationalNumber as string);
  }
}
